import { render, staticRenderFns } from "./DebtorListListView.vue?vue&type=template&id=b5ffebf0"
import script from "./DebtorListListView.vue?vue&type=script&lang=js"
export * from "./DebtorListListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports